import React from 'react';
import { ArrowRight } from 'lucide-react';
import { VALUATION_INPUT_CLS, VALUATION_BUTTON_CLS, VALUATION_BUTTON_STYLE } from './styles';

const getValuationButtonLabel = (submitted, submitting) => {
  if (submitted) return '✓ Submitted!';
  if (submitting) return 'Sending…';
  return 'Get My Valuation NOW';
};

const SelectedAddress = ({ address, onEdit, suffix }) => (
  <div className="flex items-center justify-between mb-4 pb-3 border-b-2 border-gold-400/40">
    <div className="flex-1 min-w-0">
      <p className="text-xs font-bold text-[#143160] uppercase tracking-wider">Property</p>
      <p className="text-sm font-semibold text-gray-800 truncate" title={address}>{address}</p>
    </div>
    <button type="button" onClick={onEdit} data-testid={`valuation-edit-address${suffix}`} className="ml-3 text-xs font-bold text-[#143160] hover:text-gold-600 underline min-h-[44px] px-2">
      Edit
    </button>
  </div>
);

const ConsentCheckbox = ({ checked, onChange, openPrivacyPolicy, id }) => (
  <div className="flex items-start space-x-3 bg-gold-100 p-4 rounded-xl border-2 border-gold-200">
    <input type="checkbox" id={id} data-testid={`valuation-consent${id.replace('smsConsent', '')}`} className="mt-1 w-5 h-5" checked={checked} onChange={(e) => onChange(e.target.checked)} style={{ accentColor: '#BFA26A' }} />
    <label htmlFor={id} className="text-xs text-gray-700 leading-relaxed">
      I agree to be contacted by Jess Sells East Coast via call, email, and text for real estate services. To opt-out, you can reply 'STOP' at any time or reply 'HELP' for assistance. Message and data rates may apply. Message frequency may vary.{' '}
      <button type="button" onClick={openPrivacyPolicy} className="text-[#143160] underline font-semibold hover:text-gold-600">Privacy Policy</button>.
    </label>
  </div>
);

export const ValuationStepContact = ({ form, update, onEdit, openPrivacyPolicy, submitted, submitting, suffix = '' }) => (
  <div data-testid={`valuation-step-2${suffix}`}>
    <SelectedAddress address={form.address} onEdit={onEdit} suffix={suffix} />
    <div className="text-center pb-3">
      <p className="text-sm font-semibold text-[#143160] uppercase tracking-wider">Step 2 of 2 · Almost there!</p>
      <p className="text-xs text-gray-500 mt-1">Where should Jess send your valuation?</p>
    </div>
    <div className="space-y-4">
      <input data-testid={`valuation-name${suffix}`} aria-label="Your name" className={VALUATION_INPUT_CLS} placeholder="Your Name*" required autoComplete="name" autoFocus value={form.name} onChange={(e) => update({ name: e.target.value })} />
      <input data-testid={`valuation-phone${suffix}`} aria-label="Phone number" type="tel" className={VALUATION_INPUT_CLS} placeholder="Phone Number*" required autoComplete="tel" value={form.phone} onChange={(e) => update({ phone: e.target.value })} />
      <input data-testid={`valuation-email${suffix}`} aria-label="Email address" type="email" className={VALUATION_INPUT_CLS} placeholder="Email Address*" required autoComplete="email" value={form.email} onChange={(e) => update({ email: e.target.value })} />
      <ConsentCheckbox id={`smsConsent${suffix}`} checked={form.smsConsent} onChange={(smsConsent) => update({ smsConsent })} openPrivacyPolicy={openPrivacyPolicy} />
      <button
        data-testid={`valuation-submit${suffix}`}
        type="submit"
        disabled={submitting}
        className={`${VALUATION_BUTTON_CLS} disabled:opacity-70 disabled:cursor-wait`}
        style={VALUATION_BUTTON_STYLE}
      >
        <span className="relative flex items-center justify-center">
          {getValuationButtonLabel(submitted, submitting)}
          {!submitting && <ArrowRight className="w-6 h-6 ml-2 text-gold-400" />}
        </span>
      </button>
      <p className="text-xs text-center text-gray-500 font-medium">🔒 Your information is secure and confidential.</p>
    </div>
  </div>
);
